import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { serverUrl } from "../../config";
import { useWindowSize } from "../../partials/windowSize";
import { filesystem_root, subdomain } from "../../config";

import GridItem from "../../partials/gridItem";

export default function NewsItem(props) {
  const [colSize, setColSize] = useState({ xs: 12, sm: 6, md: 3 });
  const [variant, setVariant] = useState(props.variant);
  const navigate = useNavigate();
  const { width } = useWindowSize();

  useEffect(() => {
    if (width < 768) {
      setVariant("");
      setColSize({ xs: 12, sm: 6, md: 3 });
    } else {
      handleColSize();
    }
    // eslint-disable-next-line
  }, [width]);

  const handleColSize = () => {
    if (props.index === 0 || props.index === 12) {
      setVariant("sticky");
      setColSize({ xs: 12, sm: 12, md: 12 });
    }
    // if (props.item?.sticky === "True" || props.item?.sticky === "true") {
    //   variant = "sticky";
    //   colSize = {
    //     xs: 12,
    //     sm: 12,
    //     md: 12,
    //   };
    // }
    else if (props.index === 7 || props.index === 19) {
      setVariant("featured");
      setColSize({ xs: 12, sm: 6, md: 6 });
    }
  };

  if (props.creator) {
    return (
      <GridItem
        xs={12}
        sm={6}
        md={3}
        itemClass="news"
        item={props.item}
        bundle={props.item?.bundle}
        nid={props.item?.nid}
        title={props.item?.title}
        field_body={props.item?.summary || props.item?.body}
        category_label={props.item.category_labels}
        created={props.item?.created}
        hasImg={true}
        imgSrc={`${serverUrl}/${props.item.field_featured_image}`}
        cardActionArea={true}
        creator={props.creator}
        // cardActionCallBack={() => navigate(`/news/${props.item?.nid}`)}
        contentType={props.contentType}
        shareEnabled
        route={"news"}
        field_access_token={props.item.field_access_token}
        sharePrompt={`This is a public link that enables you to share the news with your client, no login required.`}
      ></GridItem>
    );
  } else {
    const id = props.item?.nid;
    const imgSrc = `${filesystem_root}/${subdomain}/news/${id}/${id}/${props.item.field_featured_image}`;
    return (
      <GridItem
        xs={colSize.xs}
        sm={colSize.sm}
        md={colSize.md}
        itemClass="news"
        bundle={props.item?.bundle}
        nid={props.item?.nid}
        title={props.item?.title}
        field_body={props.item?.summary || props.item?.body}
        category_label={props.item.category_labels}
        created={props.item?.created}
        hasImg={true}
        imgSrc={`${serverUrl}${props.item.field_featured_image}`}
        imageRatio={variant === "featured" && "free"}
        newsVariant={variant}
        cardActionArea={true}
        cardActionCallBack={() => navigate(`/news/${props.item?.nid}`)}
        contentType={props.contentType}
        shareEnabled={props.shareEnabled}
        route={"news"}
        field_access_token={props.item?.field_access_token}
        sharePrompt={`This is a public link that enables you to share the news with your client, no login required.`}
      ></GridItem>
    );
  }
}
